import { createSlice } from '@reduxjs/toolkit'


const initialState = {
  events: null,
  current: null,
  loading: false
}

const gukSlice = createSlice({
  name: 'guk',
  initialState,
  reducers: {
    setEvents: (state, action) => ({ ...state, events: action.payload }),
    setCurrent: (state, action) => ({ ...state, current: action.payload }),
    setLoading: (state, action) => ({ ...state, loading: action.payload })
  }
})

export const { setEvents, setCurrent, setLoading } = gukSlice.actions
export default gukSlice.reducer
